const senatorialManagement = {
  en: {
    senatorialManagementPage: {
      regions: {
        "Adamawa": "Adamawa", "Centre": "Centre", "East": "East", "Far North": "Far North", "Littoral": "Littoral",
        "North": "North", "North-West": "North-West", "South": "South", "South-West": "South-West", "West": "West"
      },
      statuses: { certified: "certified", approved: "approved", decided: "decided", pending: "pending" },
      validationStatuses: {
        pending: "pending", approved: "approved", certified: "certified", rejected: "rejected", validated: "validated"
      },
      toasts: {
        liveUpdated: "Live data updated",
        newResult: "New result from {{region}}",
        unknownRegion: "unknown region",
        fillRequired: "Please fill in all required fields",
        exactlySeven: "Senatorial list must have exactly 7 candidates",
        listCreated: "Senatorial list created successfully",
        listFailed: "Failed to create list",
        pdfDownloaded: "PDF downloaded successfully",
        pdfRequiresSub: "PDF export requires a Basic subscription or higher",
        pdfFailed: "Failed to download PDF",
        xlsxDownloaded: "Excel file downloaded successfully",
        xlsxRequiresSub: "Excel export requires a Basic subscription or higher",
        xlsxFailed: "Failed to download Excel file"
      },
      title: "Senatorial Elections",
      subtitle: "10 Regions • 7 Seats per Region • List System",
      liveUpdates: "Live Updates",
      excel: "Excel",
      refresh: "Refresh",
      shareTitle: "EReMS Cameroon - Senatorial Election Results",
      shareText: "🏛️ Cameroon Senatorial Elections: {{decided}}/{{total}} regions decided, {{seats}}/70 seats allocated!",
      registerList: "Register List",
      dialog: {
        title: "Register Senatorial List",
        description: "Each list must have exactly 7 candidates (1 leader + 6 members)",
        party: "Party *",
        selectParty: "Select party",
        region: "Region *",
        selectRegion: "Select region",
        leader: "List Leader (Senator #1) *",
        leaderPlaceholder: "Leader name",
        others: "Other Candidates (#2-7)",
        senatorPlaceholder: "Senator #{{position}} name",
        cancel: "Cancel",
        create: "Create List"
      },
      tabs: { dashboard: "Dashboard", regions: "By Region", lists: "Candidate Lists" },
      stats: {
        totalRegions: "Total Regions",
        totalSeats: "Total Seats",
        perRegion: "{{count}} per region",
        regionsDecided: "Regions Decided",
        seatsDecided: "Seats Decided"
      },
      dashboard: {
        seatsByParty: "Seats Won by Party",
        winnerTakesAll: "Winner-takes-all: winning party gets all 7 seats per region",
        noResults: "No results yet",
        leadingParty: "Leading Party",
        regionsWon: "Regions Won",
        seatsWon: "Seats Won",
        regionsList: "Regions: {{list}}",
        na: "N/A"
      },
      regionsTab: {
        leader: "Leader",
        seats: "Seats",
        totalVotes: "Total Votes",
        validation: "Validation",
        awaiting: "Awaiting results",
        atStake: "{{count}} seats at stake"
      },
      listsTab: {
        candidates: "{{count}} candidates",
        listLeader: "List Leader",
        moreCandidates: "+{{count}} more candidates",
        none: "No senatorial lists registered yet",
        registerFirst: "Register First List"
      }
    }
  },
  fr: {
    senatorialManagementPage: {
      regions: {
        "Adamawa": "Adamaoua", "Centre": "Centre", "East": "Est", "Far North": "Extrême-Nord", "Littoral": "Littoral",
        "North": "Nord", "North-West": "Nord-Ouest", "South": "Sud", "South-West": "Sud-Ouest", "West": "Ouest"
      },
      statuses: { certified: "certifié", approved: "approuvé", decided: "décidé", pending: "en attente" },
      validationStatuses: {
        pending: "en attente", approved: "approuvé", certified: "certifié", rejected: "rejeté", validated: "validé"
      },
      toasts: {
        liveUpdated: "Données en direct mises à jour",
        newResult: "Nouveau résultat de la région : {{region}}",
        unknownRegion: "région inconnue",
        fillRequired: "Veuillez renseigner tous les champs obligatoires",
        exactlySeven: "Une liste sénatoriale doit comporter exactement 7 candidats",
        listCreated: "Liste sénatoriale créée avec succès",
        listFailed: "Échec de la création de la liste",
        pdfDownloaded: "PDF téléchargé avec succès",
        pdfRequiresSub: "L'export PDF nécessite un abonnement Basic ou supérieur",
        pdfFailed: "Échec du téléchargement du PDF",
        xlsxDownloaded: "Fichier Excel téléchargé avec succès",
        xlsxRequiresSub: "L'export Excel nécessite un abonnement Basic ou supérieur",
        xlsxFailed: "Échec du téléchargement du fichier Excel"
      },
      title: "Élections sénatoriales",
      subtitle: "10 régions • 7 sièges par région • Scrutin de liste",
      liveUpdates: "Mises à jour en direct",
      excel: "Excel",
      refresh: "Actualiser",
      shareTitle: "EReMS Cameroon - Résultats des élections sénatoriales",
      shareText: "🏛️ Élections sénatoriales au Cameroun : {{decided}}/{{total}} régions tranchées, {{seats}}/70 sièges attribués !",
      registerList: "Enregistrer une liste",
      dialog: {
        title: "Enregistrer une liste sénatoriale",
        description: "Chaque liste doit comporter exactement 7 candidats (1 tête de liste + 6 membres)",
        party: "Parti *",
        selectParty: "Sélectionner un parti",
        region: "Région *",
        selectRegion: "Sélectionner une région",
        leader: "Tête de liste (Sénateur n° 1) *",
        leaderPlaceholder: "Nom de la tête de liste",
        others: "Autres candidats (n° 2 à 7)",
        senatorPlaceholder: "Nom du sénateur n° {{position}}",
        cancel: "Annuler",
        create: "Créer la liste"
      },
      tabs: { dashboard: "Tableau de bord", regions: "Par région", lists: "Listes de candidats" },
      stats: {
        totalRegions: "Total des régions",
        totalSeats: "Total des sièges",
        perRegion: "{{count}} par région",
        regionsDecided: "Régions tranchées",
        seatsDecided: "Sièges attribués"
      },
      dashboard: {
        seatsByParty: "Sièges remportés par parti",
        winnerTakesAll: "Le vainqueur emporte tout : le parti gagnant obtient les 7 sièges de chaque région",
        noResults: "Aucun résultat pour le moment",
        leadingParty: "Parti en tête",
        regionsWon: "Régions remportées",
        seatsWon: "Sièges remportés",
        regionsList: "Régions : {{list}}",
        na: "N/D"
      },
      regionsTab: {
        leader: "Tête de liste",
        seats: "Sièges",
        totalVotes: "Total des voix",
        validation: "Validation",
        awaiting: "En attente des résultats",
        atStake: "{{count}} sièges en jeu"
      },
      listsTab: {
        candidates: "{{count}} candidats",
        listLeader: "Tête de liste",
        moreCandidates: "+{{count}} autres candidats",
        none: "Aucune liste sénatoriale enregistrée pour le moment",
        registerFirst: "Enregistrer la première liste"
      }
    }
  }
};

export default senatorialManagement;
